import {
  Backdrop,
  h3Style,
  h3StyleLight,
  style,
  StyledModal,
  styleWidthL,
} from "./styles";
import { Box } from "@mui/system";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

type Props = {
  open: boolean;
  onCloseResultModal?: any;
  isError: boolean;
  successMessage?: string;
  failMessage?: string;
  extraWidth?: boolean;
  setOpen?: any;
};

export const InviteResultModal = ({
  open,
  setOpen,
  extraWidth,
  onCloseResultModal,
  isError,
  successMessage,
  failMessage,
}: Props) => {
  return (
    <StyledModal
      aria-labelledby="unstyled-modal-title"
      aria-describedby="unstyled-modal-description"
      open={open}
      onClose={() => {
        if (onCloseResultModal) {
          onCloseResultModal();
        } else {
          setOpen(false);
        }
      }}
      BackdropComponent={Backdrop}
    >
      {isError ? (
        <>
          <Box sx={extraWidth ? styleWidthL : style}>
            <ErrorIcon style={{ color: "red", fontSize: "80px" }} />
            <h3
              style={
                extraWidth
                  ? { ...h3StyleLight, textAlign: "center" }
                  : { ...h3Style, textAlign: "center" }
              }
              id="unstyled-modal-description"
            >
              {failMessage ? failMessage : "User with that email already exist"}
            </h3>
          </Box>
        </>
      ) : (
        <>
          <Box sx={extraWidth ? styleWidthL : style}>
            <CheckCircleIcon style={{ color: "green", fontSize: "80px" }} />
            <h3
              style={
                extraWidth
                  ? { ...h3StyleLight, textAlign: "center" }
                  : { ...h3Style, textAlign: "center" }
              }
              id="unstyled-modal-description"
            >
              {successMessage ? successMessage : "User Invited"}
            </h3>
          </Box>
        </>
      )}
    </StyledModal>
  );
};
